<template>

    <div class="newsletter-action__content__interaction__scroll-container">
        <div class="newsletter-action__content__padding-correction">
            <div class="newsletter-action__content__step newsletter-action__content__step--final-slide">
                <h1>{{ helpers.getTranslation(translations, 'thank-you') }}</h1>
                
                <span>{{ helpers.getTranslation(translations, subscriptionConfirmed ? 'subscribe-success-message' : 'subscribe-confirm-message') }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import helpers from 'assets/js/site/helpers';

    export default {
        data: function() {
            return {
                helpers: helpers
            }
        },

        props: {
            translations: { required: true },
            subscriptionConfirmed: {Boolean, required: false, default: false}
        },

        mounted: function() {

            const self = this;

            if (!this.subscriptionConfirmed) {
                setTimeout(function(){
                    self.$emit('close')
                }, 3000);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .newsletter-action__content__interaction__scroll-container {
        margin-top: 0;
    }
    .newsletter-action__content__header-buttons .menu--cross {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/site/components/newsletter-widget/thanks-for-subscribing-slide.vue